import React from 'react'
import ScopeTemplate from '../../components/ScopeTemplate/ScopeTemplate'

function Avionics() {
    const overview =
        'We manufacture and integrate avionics electronic assemblies in compliance with stringent aerospace quality requirements. With in-house PCB fabrication, automated manufacturing facilities, and IPC-certified specialists, we ensure reliability, traceability, and performance consistency for aviation platforms.'

    const points = [
        'Multi-layer PCB fabrication & precision assembly',
        'Control, interface & signal conditioning electronics',
        'High-reliability soldering & inspection as per IPC standards',
        'Environmental & functional testing under controlled conditions',
        'End-to-end documentation, traceability & quality compliance',
    ]

    const tags = [
        'PCB Fabrication',
        'Precision Assembly',
        'Inspection',
        'Traceability',
    ]

    return (
        <ScopeTemplate
            title='AVIONICS'
            subtitle='Precision Electronic Assemblies for Aviation Platforms'
            overview={overview}
            points={points}
            tags={tags}
        />
    )
}

export default Avionics